export const FETCH_TEACHER_LOAD_COLUMNS = "FETCH_TEACHER_LOAD_COLUMNS";


export const INSERT_TEACHER_LOAD_COLUMN = "INSERT_TEACHER_LOAD_COLUMN";


export const EDIT_TEACHER_LOAD_COLUMN_INFO = "EDIT_TEACHER_LOAD_COLUMN_INFO";
